<template>
	<div class="wrapper">
		<div class="murk">
			<div class="title-header">
				<h1>
					{{ $t('wallet.reviewPurchase') }}
					<accountInfoGroup></accountInfoGroup>
					<div class="clearfix"></div>
				</h1>
			</div>

			<div v-if="region === 'global'" class="purchase-tabs-list activity-label pull-left">
				<div class="pull-left" v-for="(type, $index) in purchaseTypes"
					:class="{ selected: type === purchaseType }"
					@click="purchaseType = type"
					:key="$index">
					<span>{{ $t(`history.purchase-type.${type}`) }}</span>
				</div>
			</div>

			<formSelect
				v-if="purchaseType === 'nx'"
				v-model="filterType"
				class="form-select-wrapper pull-right"
				:inputSmall=true
				:options="filterTypes"
				name="selectFilter"
				optionsValue="val"
				optionsLabel="label"
				stringSelector="wallet"
				close-on-select>
			</formSelect>

			<div
				v-if="purchaseType === 'nx'"
			 	class="activity-label heading-label pull-right">
				{{ $t('wallet.purchaseActivities') }}
			</div>

			<div class="clearfix"></div>

			<div class="purchase-history-wrapper" :class="purchaseType">
				<v-client-table :data="rows" :columns="columns" :options="tableOptions"></v-client-table>
			</div>

			<pagination
				:records="totalRecords"
				:per-page="10"
				@paginate="fetchPage"
				ref="purchasePagination">
			</pagination>
		</div>

		<div class="modal" :class="{ hide: !historyLoading }">
			<div id="main-spinner" class="page-spinner-wrapper main-spinner">
				<span class="spinner-circle"></span>
			</div>
		</div>
	</div>
</template>

<script>
import formSelect from '@arena/toolkit/src/components/common/form-select';
import { Pagination } from 'vue-pagination-2';
import accountInfoGroup from './common/account-info-group';
import { history } from '../plugins/WalletAPI';

export default {
	name: 'history',
	components: {
		accountInfoGroup,
		formSelect,
		Pagination,
	},
	metaInfo() {
		return {
			titleTemplate: `%s | ${this.$t('wallet.reviewPurchase')}`,
		};
	},
	data() {
		return {
			loadingLabel: this.$t('wallet.loading-history', this.$route.params.locale),
			historyEntries: [],
			columns: ['date', 'orderNumber', 'description', 'amount'],
			tableOptions: {
				skin: 'table',
				columnsClasses: {
					date: 'date',
					orderNumber: 'order-number',
					description: 'description',
					amount: 'amount'
				},
				perPage: 10,
				sortable: [],
				texts: {
					filter: 'Filter:',
					filterPlaceholder: '',
					count: '',
					noResults: this.$t('wallet.no-records', this.$route.params.locale)
				},
				filterable: [],
				headings: {
					date: this.$t('wallet.date', this.$route.params.locale),
					orderNumber: this.$t('wallet.order-number', this.$route.params.locale),
					description: this.$t('wallet.description', this.$route.params.locale),
					amount: this.$t('wallet.amount', this.$route.params.locale),
				}
			},
			totalRecords: 10,
			filterType: 'all',
			filterTypes: [
				{ label: 'all', val: 'all' },
				{ label: 'add-balance', val: 'in' },
				{ label: 'in-game-item-purchase', val: 'out' },
			],
			index: 1,
			historyLoading: false,
			purchaseTypes: ['nx', 'shop', 'coupon'],
			purchaseType: 'nx'
		};
	},
	computed: {
		region() {
			return environment.region;
		},
		rows() {
			return this.historyEntries.map((entry) => {
				let sign;
				if (this.purchaseType === 'shop') {
					sign = '';
				} else if (entry.TransactionType === 'in') {
					sign = '+';
				} else {
					sign = '-';
				}
				return entry.Currency === 'NX' ? ({ // eslint-disable-line no-nested-ternary
					date: (new Date(entry.TransactionDatetime)).toLocaleDateString(`${this.$i18n.locale}-u-ca-gregory`),
					orderNumber: entry.TransactionId,
					description: entry.ItemName,
					amount: `${sign}${this.$n(entry.Amount)} ${entry.Currency}`
				}) : entry.Currency === 'TWD' ? ({
					date: (new Date(entry.TransactionDatetime)).toLocaleDateString(`${this.$i18n.locale}-u-ca-gregory`),
					orderNumber: entry.TransactionId,
					description: entry.ItemName,
					amount: `${sign}${this.$n(entry.Amount)} ${this.$t('wallet.points')}`
				}) : ({
					date: (new Date(entry.TransactionDatetime)).toLocaleDateString(`${this.$i18n.locale}-u-ca-gregory`),
					orderNumber: entry.TransactionId,
					description: entry.ItemName,
					amount: `${sign}${this.$n(entry.Amount, 'currency', entry.Currency)}`
				});
			});
		}
	},
	methods: {
		fetchPage(index) {
			if (this.index === index) return;
			const query = Object.assign({}, this.$route.query, { index });
			this.changeQuerystrings(query);
		},
		changeQuerystrings(query) {
			location.href = `${location.pathname}?${Object.keys(query).map(key => `${key}=${query[key]}`).join('&')}`;
		}
	},
	watch: {
		filterType() {
			if (this.filterType === this.$route.query.filterType) return;
			const query = Object.assign({}, this.$route.query, {
				filterType: this.filterType,
				index: 1 // index needs to be reset after type change
			});
			this.changeQuerystrings(query);
		},
		purchaseType() {
			if (this.purchaseType === this.$route.query.purchaseType) return;
			const query = Object.assign({}, this.$route.query, {
				purchaseType: this.purchaseType,
				index: 1 // index needs to be reset after type change
			});
			this.changeQuerystrings(query);
		}
	},
	created() {
		let query = this.$route.query;
		if (query.purchaseType && !this.purchaseTypes.includes(query.purchaseType)) {
			delete query.purchaseType;
		}
		query = Object.assign({ // default
			index: this.index,
			filterType: this.filterType,
			purchaseType: this.purchaseType
		}, query, { _t: Date.now() });
		this.$router.replace({
			name: this.$route.name,
			query
		});
	},
	beforeRouteUpdate(to, from, next) {
		this.index = to.query.index;
		this.filterType = to.query.filterType;
		this.purchaseType = to.query.purchaseType;
		this.historyLoading = true;
		this.$store.commit('startLoadingOverlay', this.loadingLabel);
		this.$eventBus.$emit('show-loading-overlay');
		history(this.purchaseType, this.index, this.filterType)
			.then((response) => {
				this.historyEntries = response.data.History.Transactions;
				this.totalRecords = response.data.History.Total;
				setTimeout(() => {
					this.$refs.purchasePagination.setPage(this.index);
				}, 0);
				this.$eventBus.$emit('hide-loading-overlay');
				this.historyLoading = false;
				next();
			})
			.catch((error) => {
				// console.log(error);
				next(error);
			});
	}
};

</script>

<style lang="less">
	#commerce {
		.form-select-wrapper {
			margin-top: 30px;
			width: 160px;
			.dropdown-menu {
				height: auto;
			}
		}
	}
	.activity-label {
		color: #d9d9d9;
		margin-right: 25px;
		padding-top: 58px;
	}
	.purchase-tabs-list {
		margin-bottom: 24px;
		div {
			text-transform: uppercase;
			font-weight: bold;
			&.selected {
				color: #14e0ad;
				pointer-events: none;
			}
			&:not(.selected) {
				cursor: pointer;
				span {
					color: white;
					opacity: 0.5;
					&:hover {
						opacity: 0.8;
					}
				}
			}
		}
		div + div {
			border-left: 2px solid gray;
			padding-left: 20px;
			margin-left: 20px;
		}
	}
	.purchase-history-wrapper {
		margin: 10px auto 30px;
		&.coupon {
			.amount {
				display: none;
			}
		}
		.VueTables {
			.row {
				margin: 0;
				.col-md-12:first-child {
					width: 100%;
					div {
						float: right !important;
					}
				}
				.VueTables__limit {
					display: none;
				}
			}
			.VueTables__no-results {
				td {
					text-align: center !important;
				}
			}
			.table {
				.date { width: 10%; }
				.order-number { width: 37%; }
				.description { width: 40%; }
				.amount { width: 13%; }
			}
		}
		.VueTables__highlight {
			b {
				color: #40d0ba;
			}
		}
	}

	.VuePagination {
		text-align: center;
		.VuePagination__pagination-item-prev-chunk,
		.VuePagination__pagination-item-next-chunk {
			.page-link {
				display: none;
			}

		}
		.VuePagination__count {
			display: none;
		}
		.VuePagination__pagination-item-prev-page,
		.VuePagination__pagination-item-next-page {
			&.disabled {
				opacity: .5;
			}
			a {
				background:url("data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 20.25 36'><path fill='%23fff' d='M19.29,24l14.2-14.2a2.23,2.23,0,1,0-3.16-3.15L14.55,22.45a2.23,2.23,0,0,0,0,3.15L30.33,41.37a2.23,2.23,0,1,0,3.16-3.15Z' transform='translate(-13.9 -6.03)'/></svg>") no-repeat top left;
				height: 14px;
				width: 14px;
				color: transparent;
				margin-top: 9px;
				opacity: .5;
				transition: .3s ease;
				&:hover,
				&:focus {
					opacity: 1;
					color: transparent;
					background-color: transparent;
				}
			}
		}
		.VuePagination__pagination-item-prev-page {
			a {
				background: url("data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 20.25 36'><path fill='%23fff' d='M19.29,24l14.2-14.2a2.23,2.23,0,1,0-3.16-3.15L14.55,22.45a2.23,2.23,0,0,0,0,3.15L30.33,41.37a2.23,2.23,0,1,0,3.16-3.15Z' transform='translate(-13.9 -6.03)'/></svg>") no-repeat top left;
			}
		}
		.VuePagination__pagination-item-next-page {
			a {
				background: url("data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 20.25 36'><path fill='%23fff' d='M33.49,22.45,17.7,6.68a2.23,2.23,0,0,0-3.15,3.16L28.75,24,14.55,38.22a2.23,2.23,0,1,0,3.15,3.15L33.49,25.6A2.23,2.23,0,0,0,33.49,22.45Z' transform='translate(-13.89 -6.03)'/></svg>") no-repeat top right;
			}
		}
		.page-link {
			color: #d9d9d9;
			background-color: transparent;
			border-color: transparent;
		}
		.active {
			.page-link {
				background-color: #d9d9d9;
				border-color: #d9d9d9;
				color: #000;
				&:hover,
				&:focus {
					background-color: #d9d9d9;
					border-color: #d9d9d9;
					color: #000;
				}
			}
		}

	}
	@media (max-width: 900px) {
		#commerce {
			.purchase-tabs-list {
				display: block;
				width: 100%;
				margin-bottom: 0;
				paddint-top: 30PX;
			}
			.form-select-wrapper {
				margin-top: 3px;
			}
		}
	}
	@media (max-width: 767px) {
		#commerce {
			.purchase-tabs-list {
				div {
					margin-bottom: 10px;
				}
			}
			.form-select-wrapper {
				margin-top: 5px;
			}
			.activity-label {
				padding-top: 33px;
			}

			.purchase-history-wrapper {
				margin: 10px auto
			}
			.VueTables {
				th {
					color: #d9d9d9;
				}
				.table-responsive {
					border: none;
				}
				.form-control {
					display: inline-block;
					width: auto;
				}
				thead tr {
					display: none;
				}
				tbody {
					border-top: 2px solid #999;
					tr {
						border-bottom: 1px solid #383838;
						padding: 5px 0;
						td {
							&:first-child {
								padding-top: 20px;
							}
							&:last-child {
								padding-bottom: 20px;
								font-weight: bold;
							}
							display: block;
							padding: 7px 0;
							border-bottom: transparent !important;
							&.amount {
								color: #d9d9d9;
								text-align: left;
							}
						}
					}
				}
			}
		}
	}
	@media (max-width: 480px) {
		#commerce {
			.form-select-wrapper {
				margin-top: 0;
				width: 100%;
			}
			.activity-label {
				&.heading-label {
					display: none;
				}
			}
			.purchase-tabs-list {
				margin-bottom: 0;
			}
		}
		.VueTables {
			.VueTables__search {
				width: 100%;
			}
			.form-control {
				display: block;
				width: 100%;
			}
		}
	}
</style>



// WEBPACK FOOTER //
// src/components/history.vue